(function () {
  var VARIANTS = {
    TYPE1_SUPER_OUTLET:  {"54":"46095829762203","58":"46095829794971","62":"46095829827739","66":"46095829860507","70":"46095829893275","74":"46095829926043"},
    TYPE1_CLASSIC_OUTLET:{"54":"46100192395419","58":"46100192428187","62":"46100192460955","66":"46100192493723","70":"46100192526491","74":"46100192559259"},
    TYPE1_SUPER:         {"54":"40715384586395","58":"40715384684699","62":"40715384717467","66":"40715384783003","70":"40715384881307","74":"40715384946843"},
    TYPE1_CLASSIC:       {"54":"40715379671195","58":"40715379703963","62":"40715379736731","66":"40715379769499","70":"40715379802267","74":"40715379835035"},
    CLASSIC_TYPE2:       {"54":"45559210311835","58":"45559210344603","62":"45559210377371","66":"45559210410139","70":"45559210442907","74":"45559210475675"},
    SUPER_TYPE2:         {"54":"45559194222747","58":"45559194255515","62":"45559194288283","66":"45559194321051","70":"45559194353819","74":"45559194386587","78":"46723395125403"},
    TRUCK:               {"78":"40715525783707","80":"40715525816475","88":"40715525849243","90":"40715525882011","92":"42945909489819","94":"42946015625371","96":"42946029355163","98":"42946032402587","100":"42946034729115","102":"42946038071451","104":"42946041774235","106":"42946047639707","108":"42946050523291","110":"42946052948123"},
    RECYCLED:            {"54":"46641068376219","58":"46641092952219","62":"46641092984987","66":"46641093017755","70":"46641093050523","74":"46641093083291"},
    SUBENE:              {"54":"46691441410203","58":"46691441442971","62":"46691441475739","66":"46691441508507","70":"46691441541275","74":"46691441574043"}
  };

  var URL_MAPPINGS = [
    ["isse-snowsocks-super-outlet",   "TYPE1_SUPER_OUTLET"],
    ["isse-snowsocks-classic-outlet", "TYPE1_CLASSIC_OUTLET"],
    ["isse-snowsocks-super-type-2",   "SUPER_TYPE2"],
    ["isse-snowsocks-super",          "TYPE1_SUPER"],
    ["isse-snowsocks-classic-type-2", "CLASSIC_TYPE2"],
    ["isse-snowsocks-classic",        "TYPE1_CLASSIC"],
    ["isse-snowsocks-truck",          "TRUCK"],
    ["recycled",                      "RECYCLED"],
    ["subene",                        "SUBENE"]
  ];

  var SPECIAL_SIZES = {
    "7 - 15":"74","7 - 16":"74","8.25 - 20":"94","8.5 - 17.5":"78",
    "8.5 - 20":"94","9.0 - 19.5":"80","9 - 16":"90","9 - 22.5":"94",
    "9.5 - 17.5":"80","10 - 20":"102","10 - 22.5":"96","11 - 22.5":"98",
    "11 - 24.5":"104","12 - 20":"106","12 - 22.5":"106","35/12.5 - 20":"90",
    "12,5/70 - 16":"80","15,5/60 - 18":"94"
  };

  window.SFCore = {
    getProductMapping: function () {
      var url = window.location.href;
      for (var i = 0; i < URL_MAPPINGS.length; i++) {
        if (url.indexOf(URL_MAPPINGS[i][0]) !== -1) return URL_MAPPINGS[i][1];
      }
      return "NONE";
    },

    getShopLink: function (size, productMapping) {
      var sizeKey = String(parseInt(size, 10));
      // 乗用車の78（XXXL）はスーパー TYPEⅡだけ。78が無い商品・一覧からはスーパー TYPEⅡの商品ページへ案内（2026-10-05）
      if (/XXXL/.test(size) && !(VARIANTS[productMapping] || {})[sizeKey]) return "PRODUCT:/products/isse-snowsocks-super-type-2";
      if (productMapping === "NONE") return "LINEUP";
      var variant = (VARIANTS[productMapping] || {})[sizeKey] || "";
      return variant ? "https://issechains.jp/cart/" + variant + ":1" : "#";
    },

    calcPerimeter: function (width, border, rim) {
      var rimDiameterCm = rim * 2.54;
      var sidewallHeightCm = (width * (border / 100)) / 10;
      var tireDiameterCm = rimDiameterCm + (2 * sidewallHeightCm);
      return Number((Math.PI * tireDiameterCm).toFixed(2));
    },

    judgeSize: function (peri) {
      if (peri >= 155 && peri < 174) return "54 ( XS )";
      if (peri >= 174 && peri < 186) return "58 ( S )";
      if (peri >= 186 && peri < 200) return "62 ( M )";
      if (peri >= 200 && peri < 215) return "66 ( L )";
      if (peri >= 215 && peri < 234) return "70 ( XL )";
      if (peri >= 234 && peri < 256) return "74 ( XXL )";
      if (peri >= 256 && peri < 266) return "78（XXXL）※スーパー TYPEⅡのみ";
      if (peri >= 266 && peri < 272) return "80";
      if (peri >= 272 && peri < 279) return "88";
      if (peri >= 279 && peri < 287) return "90";
      if (peri >= 287 && peri < 291) return "92";
      if (peri >= 291 && peri < 313) return "94";
      if (peri >= 313 && peri < 320) return "96";
      if (peri >= 320 && peri < 330) return "98";
      if (peri >= 330 && peri < 339) return "100";
      if (peri >= 339 && peri < 343) return "102";
      if (peri >= 343 && peri < 349) return "104";
      if (peri >= 349 && peri < 355) return "106";
      if (peri >= 355 && peri < 363) return "108";
      if (peri >= 363 && peri < 372) return "110";
      return "対応商品がありません。";
    },

    judgeSpecialSize: function (val) {
      return SPECIAL_SIZES[val] || "対応商品がありません。";
    },

    toHalf: function (v) {
      return v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    },

    hasFull: function (v) {
      return /[Ａ-Ｚａ-ｚ０-９]/.test(v);
    },

    addToCart: function (variantId) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) { return r.json(); });
    }
  };
})();
